import Swiper from 'swiper';

export default class FormRules {
  constructor() {
    this.slider = document.querySelector('.swiper-slider1');
  }

  init() {
    if (this.slider) {
      this.initSlider();
    }
  }

  initSlider() {
    const swiper = new Swiper('.swiper-slider1', {
      loop: true,
      loopAdditionalSlides: 2,
      slidesPerView: 1.2,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        480: {
          slidesPerView: 1.5,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
    });
  }
}
